import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import { Mediator } from 'com-gyf-webcore-mediator';

//Valida la existencia de la URL seteada en el menu del usuario actual.
function pathValidator(cantRoutes, currentScope, userMenu) {
    let result = true;
    let reservedHashes = ["#/", "#/login", "#/notfound"];
    let productCode = currentScope.ProductCode;
    let categoryCode = currentScope.CategoryCode;
    let programCode = currentScope.ProgramCode;
    let product = null;
    let category = null;
    let program = null;
    let screen = null;

    let categories = undefined;
    let programs = undefined;

    switch (cantRoutes) {
        case 2:
            if (!reservedHashes.includes(location.hash)) {
                if (productCode == null) {
                    result = false;
                } else {
                    product = userMenu.filter(
                        x => x.codigo.toUpperCase() === productCode.toUpperCase()
                    );

                    if (product.length <= 0)
                        result = false;
                }
            }

            break;
        case 3:
            //Hotfix para el routeo a cambio de contrase�a.
            //TODO: No enviar el ID de usuario como par�metro y que la pantalla lo obtenga del state.
            if (location.hash.split("/")[1] != "cambiocontrasena") {
                if (productCode == null) {
                    result = false;
                } else {
                    product = userMenu.filter(
                        x => x.codigo.toUpperCase() === productCode.toUpperCase()
                    );

                    if (product.length <= 0) {
                        result = false;
                    } else {
                        if (categoryCode == null) {
                            result = false;
                        } else {
                            categories = product[0].categorias;

                            category = categories.filter(
                                x => x.codigo.toUpperCase() === categoryCode.toUpperCase()
                            );

                            if (category.length <= 0)
                                result = false;
                        }
                    }
                }
            }            

            break;
        case 4, 5:
            if (productCode == null) {
                result = false;
            } else {
                product = userMenu.filter(
                    x => x.codigo.toUpperCase() === productCode.toUpperCase()
                );

                if (product.length <= 0) {
                    result = false;
                } else {
                    if (categoryCode == null) {
                        result = false;
                    } else {
                        categories = product[0].categorias;

                        category = categories.filter(
                            x => x.codigo.toUpperCase() === categoryCode.toUpperCase()
                        );

                        if (category.length <= 0) {
                            result = false;
                        } else {
                            if (programCode == null) {
                                result = false;
                            } else {
                                programs = category[0].programas;

                                program = programs.filter(
                                    x => x.codigo.toUpperCase() === programCode.toUpperCase()
                                );

                                if (program.length <= 0)
                                    result = false;
                            }
                        }
                    }
                }
            }
            break;

        default:
            break;
    }
    
    return result;
};

const AppRoute = ({ exact, path, component, isPrivate, isAuthenticated, executionContext, userId, menuUsuario }) => {
    let currentScope = null; //TODO: Sacar cuando se empiece a utilizar executionContext en las pantallas.
    let currentExecutionContext = null;
    let cantRoutes = null;
    let hash = location.hash;
    let validPath = null;

    let Component = component;
    let splitedPath = hash.split("/");

    if (splitedPath != undefined)
        cantRoutes = splitedPath.length;

    currentScope = {
        "UserId": userId,
        "ProductCode": (splitedPath[1] == undefined) ? null : splitedPath[1],
        "CategoryCode": (splitedPath[2] == undefined) ? null : splitedPath[2],
        "ProgramCode": (splitedPath[3] == undefined) ? null : splitedPath[3]
    } //TODO: Sacar cuando se empiece a utilizar executionContext en las pantallas.

    //Obtengo ExecutionContext recibido en el login, el de Portico. Lo modifico con la URL.
    if (executionContext != null && executionContext != undefined) {
        currentExecutionContext = JSON.parse(JSON.stringify(executionContext));
        currentExecutionContext.ProductCode = (splitedPath[1] == undefined) ? null : splitedPath[1];
        currentExecutionContext.CategoryCode = (splitedPath[2] == undefined) ? null : splitedPath[2];
        currentExecutionContext.FeatureCode = null;
        currentExecutionContext.ProgramCode = (splitedPath[3] == undefined) ? null : splitedPath[3];
    }

    validPath = pathValidator(cantRoutes, currentScope, menuUsuario); //TODO: Utilizar el scope de currentExecutionContext cuando se saque currentScope.

    if (validPath == false) {
        //return <Redirect to='/notfound' />;
        let newPath = '/';
        if (menuUsuario.length > 0)
            newPath += menuUsuario[0].codigo.toString() + '/';

        return <Redirect to={newPath} />;
    }

    if (isPrivate && !isAuthenticated)
        return <Redirect to='/login' />;
    else return (
        //TODO: Sacar currentScope de las props enviadas cuando se deje de usar.
        <Route exact={exact} path={path} render={props => <Component executionContext={currentExecutionContext} currentScope={currentScope} {...props} />} />
    );
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.sesion.loggedIn,
        executionContext: state.sesion.executionContext,
        userId: (state.sesion.userId == null) ? null : state.sesion.userId,
        menuUsuario: state.menuProductos.menuUsuario
    }
}

const mapDispatchToProps = (dispatch, ownProps) => { }

const ConnectedAppRoute = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppRoute)

export default ConnectedAppRoute;



// WEBPACK FOOTER //
// ./Portico/App/Routes/AppRoute.js